import { TradingAccountActivityPerGroupingDto } from './TradingAccountActivityPerGroupingDto'

export interface WelcomeAccountIpActivityDto {
  ipAddress: string | null
  count: number
  welcomeAccounts: TradingAccountActivityPerGroupingDto[]
}

export enum WelcomeAccountIpActivityDtoKey {
  ipAddress = 'ipAddress',
  count = 'count',
}
